// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f50a93a","238":"e5f608ce","239":"243bf010","732":"848178f9"}[chunkId] + ".chunk.js";
};